import { format } from 'date-fns'

export const formatYMDHMS = (value) => {
  if (!value) return ''
  const normalizedValue = value.toString().length === 10 ? Number(value) * 1000 : value
  const date = new Date(normalizedValue)
  if (Number.isNaN(date.getTime())) return ''
  return format(date, 'yyyy-MM-dd HH:mm:ss')
}

export const getHoursFromSeconds = (seconds) => {
  const hours = seconds / 3600
  return parseFloat(hours.toFixed(2))
}
